import { render, staticRenderFns } from "./SubscribersCard.vue?vue&type=template&id=ffcd31d2&scoped=true&"
import script from "./SubscribersCard.vue?vue&type=script&lang=js&"
export * from "./SubscribersCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscribersCard.vue?vue&type=style&index=0&id=ffcd31d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcd31d2",
  null
  
)

export default component.exports